import { render, staticRenderFns } from "./TeamEvent.vue?vue&type=template&id=0cb0882e&scoped=true&"
import script from "./TeamEvent.vue?vue&type=script&lang=ts&"
export * from "./TeamEvent.vue?vue&type=script&lang=ts&"
import style0 from "./TeamEvent.vue?vue&type=style&index=0&id=0cb0882e&prod&scoped=true&lang=css&"
import style1 from "./TeamEvent.vue?vue&type=style&index=1&id=0cb0882e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb0882e",
  null
  
)

export default component.exports